"use client"

import { GlobalStyles } from "@mui/material"

const printStyles = {
  "@media print": {
    /* Always hide sidebar/drawer/nav in print — for ALL pages */
    "nav, .MuiDrawer-root, .MuiDrawer-root *": {
      display: "none !important",
      visibility: "hidden !important",
      width: "0 !important",
      height: "0 !important",
      overflow: "hidden !important",
    },
    /* Only hide main page content when print view is present (read-only statuses) */
    "body:has(#print-only-view) #main-wapper, body:has(#print-only-view) #layout":
      {
        visibility: "hidden !important",
        height: "0 !important",
        minHeight: "0 !important",
        overflow: "hidden !important",
        padding: "0 !important",
        margin: "0 !important",
      },
    /* Hide footer, appbar, and the environment (Practice/Test) banner when print view is present */
    "body:has(#print-only-view) footer, body:has(#print-only-view) .MuiAppBar-root, body:has(#print-only-view) #environment-alert":
      {
        display: "none !important",
      },
    /* Reset body when print view is present */
    "body:has(#print-only-view)": {
      width: "100% !important",
      height: "auto !important",
      overflow: "visible !important",
      margin: "0 !important",
      padding: "0 !important",
    },
    "html:has(#print-only-view)": {
      width: "100% !important",
      height: "auto !important",
      overflow: "visible !important",
      margin: "0 !important",
      padding: "0 !important",
    },
    /* Show the print view and all its children */
    "#print-only-view, #print-only-view *": {
      visibility: "visible !important",
    },
    /* Print view: absolute overlay, full width */
    "#print-only-view": {
      display: "block !important",
      position: "absolute !important",
      left: "0 !important",
      top: "0 !important",
      width: "100% !important",
      margin: "0 !important",
      padding: "0 8px !important",
      boxSizing: "border-box !important",
      zIndex: "99999 !important",
      overflow: "visible !important",
      fontSize: "6px !important",
      lineHeight: "1.3 !important",
      fontWeight: "400 !important",
      fontFamily: "'Source Sans 3', sans-serif !important",
      color: "#1E2C3F !important",
    },
    /* Watermark: centered on every page */
    "#print-watermark": {
      display: "block !important",
      visibility: "visible !important",
      position: "fixed !important",
      top: "50% !important",
      left: "50% !important",
      transform: "translate(-50%, -50%) !important",
      width: "50% !important",
      opacity: "0.07 !important",
      pointerEvents: "none !important",
      zIndex: "0 !important",
    },
    "#print-content": {
      position: "relative !important",
      zIndex: "1 !important",
    },
    /* Table cells: compact, no MUI min-height */
    "#print-only-view td, #print-only-view th": {
      fontSize: "6px !important",
      lineHeight: "1.3 !important",
      height: "auto !important",
      minHeight: "0 !important",
      verticalAlign: "top !important",
    },
    "#print-only-view tr": {
      height: "auto !important",
      minHeight: "0 !important",
    },
    "#print-only-view table": {
      width: "100% !important",
      tableLayout: "fixed !important",
      borderCollapse: "collapse !important",
      borderSpacing: "0 !important",
    },
    /* 2-column layout: 4 equal columns — also handle 5-column process table */
    "#print-only-view td:nth-child(1), #print-only-view th:nth-child(1)": {
      width: "25% !important",
    },
    "#print-only-view td:nth-child(2), #print-only-view th:nth-child(2)": {
      width: "25% !important",
    },
    /* Prevent product groups splitting across pages */
    "#print-only-view .print-product-group": {
      breakInside: "avoid !important",
      pageBreakInside: "avoid !important",
    },
    /* Ensure backgrounds print */
    "*": {
      printColorAdjust: "exact",
      WebkitPrintColorAdjust: "exact",
    },
    "@page": {
      margin: "0.5cm 0.6cm",
      size: "A4 portrait",
    },
  },
  /* Hide print view on screen — keep in DOM for :has() selector */
  "#print-only-view": {
    visibility: "hidden",
    position: "absolute",
    left: "-9999px",
    width: "0",
    height: "0",
    overflow: "hidden",
  },
} as const

export function PrintStyles() {
  return <GlobalStyles styles={printStyles} />
}
